export const LOGIN = "LOGIN"
export const REGISTER = "REGISTER"
export const LOGOUT = "LOGOUT"
export const UNAUTHORIZED = "UNAUTHORIZED"
export const ERROR_AUTH = "ERROR_AUTH"
